import TextValuePreview from './TextValuePreview';
import TextValueView from './TextValueView';
import TextValueEdit from './TextValueEdit';

const textValue = {
	preview: TextValuePreview,
	view: TextValueView,
	edit: TextValueEdit,
};
export default textValue;
